import { Input } from "@material-tailwind/react";
import React from "react";

const BasicInputField = ({
  name,
  handleChange,
  type,
  value,
  emailError,
  placeholder,
  fieldSize,
  errorMessage,
  className,
  readOnly,
  ...props
}) => {
  return (
    <div>
      <Input
      readOnly={readOnly}
      size={fieldSize}
        name={name}
        value={value}
        onChange={handleChange}
        type={type}
        error={emailError}
        className={`bg-transparent autofill:!shadow-[inset_0_0_0px_1000px_rgb(255,255,255)] text-gray-900 text-sm rounded-lg block w-full p-2.5  ${className}`}
        placeholder={placeholder}
        required
        {...props}
      />
      {emailError && (
        <p className="mt-2 text-sm text-red-600">
          <span className="font-medium">{errorMessage}</span>
        </p>
      )}
    </div>
  );
};

export default BasicInputField;
